import { Link } from "react-router-dom";
import BrandMark from "@/components/base/BrandMark";
import SiteButton from "@/components/site/SiteButton";
import { CONTACT } from "@/config/contact";

interface LandingFooterProps {
  onRequest: () => void;
}

const sections = [
  { label: "Plateforme", href: "#plateforme" },
  { label: "Modules", href: "#fonctionnalites" },
  { label: "Démarrer", href: "#etapes" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function LandingFooter({ onRequest }: LandingFooterProps) {
  return (
    <footer className="border-t border-background-200 bg-white">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <nav
          className="flex flex-wrap items-center gap-x-7 gap-y-3 border-b border-background-200 py-6 text-[0.95rem]"
          aria-label="Pied de page"
        >
          <span className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Sur cette page</span>
          {sections.map((s) => (
            <a key={s.href} href={s.href} className="text-foreground-700 hover:text-primary-700">
              {s.label}
            </a>
          ))}
        </nav>

        <div className="flex flex-col gap-6 py-8 md:flex-row md:items-center md:justify-between">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <BrandMark />
              <span className="text-lg font-bold font-heading text-primary-950">
                Waitech<span className="text-primary-500">Edu</span>
              </span>
            </Link>
            <p className="mt-2 text-sm text-foreground-500">
              © {new Date().getFullYear()} WaitechEdu · {CONTACT.city}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[0.95rem]">
            <Link to="/login" className="text-foreground-700 hover:text-primary-700">
              Se connecter
            </Link>
            <Link to="/suivre-demande" className="text-foreground-700 hover:text-primary-700">
              Suivre ma demande
            </Link>
            <a href={`mailto:${CONTACT.email}`} className="text-foreground-700 hover:text-primary-700">
              {CONTACT.email}
            </a>
          </div>

          <SiteButton onClick={onRequest} icon="ri-arrow-right-line" className="self-start md:self-auto">
            Demander un compte
          </SiteButton>
        </div>
      </div>
    </footer>
  );
}
